import { c as _c } from "react/compiler-runtime";
import { useNavigate } from 'react-router-dom';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useAppDispatch } from '../../../store/hooks';
import { createWorkTimeEntrySlice } from '../../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
import { useTodaysWorkTimeEntries } from '../../entity/workTimeEntry/useTodaysWorkTimeEntries/useTodaysWorkTimeEntries';
export function useStartCreatingWorkTimeEntryWithoutStopwatch() {
  const $ = _c(6);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const workTimeEntries = useTodaysWorkTimeEntries();
  let t0;
  if ($[0] !== dispatch || $[1] !== navigate || $[2] !== workTimeEntries) {
    t0 = t1 => {
      const {
        userGroupId
      } = t1;
      const lastWorkTimeEntry = workTimeEntries[workTimeEntries.length - 1];
      const currentIsoDate = new Date().toISOString();
      const startDate = lastWorkTimeEntry?.endDate ?? currentIsoDate;
      const endDate = startDate < currentIsoDate ? currentIsoDate : startDate;
      dispatch(createWorkTimeEntrySlice.actions.startCreation({
        startDate,
        endDate,
        breaks: [],
        note: "",
        userGroupId,
        stopwatchId: null
      }));
      navigate(RoutePaths.createWorkTimeEntry());
    };
    $[0] = dispatch;
    $[1] = navigate;
    $[2] = workTimeEntries;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const startCreatingWorkTimeEntryWithoutStopwatch = useEventCallback(t0);
  let t1;
  if ($[4] !== startCreatingWorkTimeEntryWithoutStopwatch) {
    t1 = {
      startCreatingWorkTimeEntryWithoutStopwatch
    };
    $[4] = startCreatingWorkTimeEntryWithoutStopwatch;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
export type UseStartCreatingWorkTimeEntryWithoutStopwatchReturnValue = {
  startCreatingWorkTimeEntryWithoutStopwatch: StartCreatingWorkTimeEntryWithoutStopwatch;
};
export type StartCreatingWorkTimeEntryWithoutStopwatch = (options: {
  userGroupId: string;
}) => void;